module.exports = "<app-header></app-header>\n<router-outlet></router-outlet>\n<app-footer *ngIf=\"global.showFooter$ | async\"></app-footer>"